export default {
  data: () => ({
    resizeObserver: null,
  }),

  methods: {
    updateScrollEffects($event) {
      requestAnimationFrame(() => {
        const element = $event?.target;
        const scrollableWrapper = element?.parentElement?.parentElement?.parentElement;
        if (!scrollableWrapper) {
          return;
        }

        const limitX = element.scrollWidth - 5;
        const limitY = element.scrollHeight - 5;
        const scrolledX = element.offsetWidth + element.scrollLeft;
        const scrolledY = element.offsetHeight + element.scrollTop;

        scrollableWrapper.style.setProperty('--top-shadow-opacity', element.scrollTop === 0 ? 0 : 1);
        scrollableWrapper.style.setProperty('--bottom-shadow-opacity', scrolledY >= limitY ? 0 : 1);
        scrollableWrapper.style.setProperty('--left-shadow-opacity', element.scrollLeft === 0 ? 0 : 1);
        scrollableWrapper.style.setProperty('--right-shadow-opacity', scrolledX >= limitX ? 0 : 1);
      });
    },

    forceContentRedraw(container, innerContainer) {
      if (!container || !innerContainer) {
        return;
      }

      // We hide the card using `hidden` to force the recalc operation on the element
      // when it goes back to being visible and leverage the opacity yet-another-frame
      // later so the user doesn't see the chart resizing
      container.hidden = true;
      container.style.setProperty('opacity', '0');

      // Clearing both properties with 1 frame between each operation
      requestAnimationFrame(() => {
        container.hidden = false;

        requestAnimationFrame(() => {
          container.style.setProperty('opacity', '');

          // Once the redraw has completed, reset the scroll
          this.resetScroll(innerContainer);
        });
      });
    },

    resetScroll(element) {
      if (!element) {
        return;
      }

      requestAnimationFrame(() => {
        element.scrollTop = 0;
        element.scrollLeft = 0;
      });
    },

    refreshScrollEffect(container) {
      if (!container) {
        return;
      }

      // We need to trigger a scroll event to cause the effects to appear.
      // The event needs to happen after the internal elements have been
      // rendered, so we wait 150ms for safety.
      setTimeout(() => container.dispatchEvent(new Event('scroll')), 150);
    },

    setupResizeObserver(container) {
      if (!container) {
        return;
      }

      this.refreshScrollEffect(container);

      this.resizeObserver = new ResizeObserver(() => this.refreshScrollEffect(container));
      this.resizeObserver.observe(container);
    },

    tearDownResizeObserver(container) {
      if (!container) {
        return;
      }

      this.resizeObserver.unobserve(container);
      this.resizeObserver.disconnect();
    },
  },
}
